import useI18n from 'src/hooks/useI18n'

interface Props {
  appliedSort: string;
  handlesApply: (
    paramsTags: Record<string, string[]> | null,
    paramsProperties: Record<string, string[]> | null,
    paramsSort: string | null,
    paramsMinPrice: number | null,
    paramsMaxPrice: number | null
  ) => void;
}

const FilterdSort = (props: Props) => {
  const { appliedSort, handlesApply } = props

  const translation = useI18n()
  const sortOptions = [{ title: translation.filter.sort.newest, value: 'newest' }, { title: translation.filter.sort.oldest, value: 'oldest' }, { title: translation.filter.sort.lowest, value: 'lowest_price' }, { title: translation.filter.sort.highest, value: 'highest_price' }, { title: translation.filter.sort.az, value: 'az' }, { title: translation.filter.sort.za, value: 'za' }]

  return (
    <div className="filtered-sort filtered-type">
      <div className="filtered-item">
        <span>{sortOptions.find((sortOption) => sortOption.value === appliedSort)?.title}</span>
        <button aria-label={`Limpar filtro de ordenação: ${sortOptions.find((sortOption) => sortOption.value === appliedSort)?.title}`} className="filtered-items-button-clear" onClick={() => handlesApply(null, null, '', null, null)}></button>
      </div>
    </div>
  )
}

export default FilterdSort
